import { DispatchLoading, DispatchType, ResponseValid } from 'domain/utils/ReactUtils'
import { GET_CATEIRA_USUARIO, CARTEIRA_BASE_CAMPANHA_GET, CARTEIRA_BASE_GET, CARTEIRA_BASE_UPDATE } from 'domain/types/_carteira/carteiraBase/carteiraBase';
import { CarteiraBaseService } from 'domain/services/home/carteiraBaseService';
import { StateType } from 'domain/types/base/base';
import { AppThunk } from 'base/src/utils/reducerUtil';
import { CarteiraBaseResponse } from 'domain/types/_carteira/carteiraBase/carteiraBaseResponse';
import { _UserData, UserDataBaseEnum} from 'base/src/infra/storage/localStorage';
import { CarteiraUsuarioResponse } from 'domain/types/_carteira/carteiraBase/carteiraUsuarioResponse';

const _CarteiraBaseService = new CarteiraBaseService();

export function UpdateCarteiraBase(carteiraBase: CarteiraBaseResponse): AppThunk {
    return async (dispatch) => {
        dispatch({
            payload: carteiraBase,
            type: CARTEIRA_BASE_UPDATE,
        })
    }
}

export function GetCarteiraBase(carteiraId: number): AppThunk {
    return async (dispatch) => {
        dispatch(DispatchLoading(CARTEIRA_BASE_GET, DispatchType.LOADING, 'Carregando', StateType.Master))

        const asyncResponse = await _CarteiraBaseService.GetCarteiraBase(carteiraId);

        if (ResponseValid(asyncResponse, false)) {
            dispatch({
                payload: asyncResponse,
                type: CARTEIRA_BASE_GET,
            })
        } else {
            dispatch(DispatchLoading(CARTEIRA_BASE_GET, DispatchType.ERROR, "Erro ao obter infomações", StateType.Master))
        }
    }
}

export function GetCarteiraBasePorCampanha(campanhaId: number, carteiraId: number): AppThunk {
    return async (dispatch) => {
        dispatch(DispatchLoading(CARTEIRA_BASE_CAMPANHA_GET, DispatchType.LOADING, 'Carregando', StateType.Master))

        const asyncResponse = await _CarteiraBaseService.GetCarteiraBasePorCarteira(carteiraId, campanhaId);

        if (ResponseValid(asyncResponse, false)) {
            dispatch({
                payload: asyncResponse,
                type: CARTEIRA_BASE_CAMPANHA_GET
            })
        } else {
            dispatch(DispatchLoading(CARTEIRA_BASE_CAMPANHA_GET, DispatchType.ERROR, "Erro ao obter infomações", StateType.Master))
        }
    }
}

export function GetCarteiraUsuario(callBack?: () => void) : AppThunk {
    return async (dispatch) => {
        dispatch(DispatchLoading(GET_CATEIRA_USUARIO, DispatchType.LOADING, 'Carregando', StateType.Master))

        const asyncResponse = await _CarteiraBaseService.GetCarteiraUsuario(_UserData.Get(UserDataBaseEnum.UsuarioID), _UserData.Get(UserDataBaseEnum.EmpresaID));

        if (ResponseValid(asyncResponse)) {
            dispatch({
                payload: asyncResponse,
                type: GET_CATEIRA_USUARIO
            })
            _UserData.SetOtherData('CarteiraID', (asyncResponse as CarteiraUsuarioResponse[])[0].CarteiraID.toString());
        } else {
            dispatch(DispatchLoading(GET_CATEIRA_USUARIO, DispatchType.ERROR, "Erro ao obter infomações", StateType.Master, callBack))
        }
    }
}